import axiosInstance from "../axiosConfig";

// Helper function to format errors consistently
const formatError = (error) => {
  if (error.response?.data) {
    // If it's an axios error with response data
    if (typeof error.response.data === "string") {
      return { message: error.response.data };
    } else if (error.response.data.error) {
      return { message: error.response.data.error };
    } else if (error.response.data.message) {
      return { message: error.response.data.message };
    } else {
      return { message: "Server error occurred" };
    }
  } else if (error.message) {
    return { message: error.message };
  } else {
    return { message: "An unexpected error occurred" };
  }
};

export const getAllInvoices = async (filters = {}) => {
  try {
    const response = await axiosInstance.get("/invoices", { params: filters });
    return response.data;
  } catch (error) {
    throw formatError(error);
  }
};

export const getInvoiceById = async (id) => {
  try {
    const response = await axiosInstance.get(`/invoices/${id}`);
    return response.data;
  } catch (error) {
    throw formatError(error);
  }
};

export const createInvoice = async (invoiceData) => {
  try {
    const response = await axiosInstance.post("/invoices", invoiceData);
    return response.data;
  } catch (error) {
    throw formatError(error);
  }
};

export const updateInvoice = async (id, invoiceData) => {
  try {
    const response = await axiosInstance.put(`/invoices/${id}`, invoiceData);
    return response.data;
  } catch (error) {
    throw formatError(error);
  }
};

export const deleteInvoice = async (id) => {
  try {
    const response = await axiosInstance.delete(`/invoices/${id}`);
    return response.data;
  } catch (error) {
    throw formatError(error);
  }
};

export const getInvoiceByNumber = async (number) => {
  try {
    // Backend route is GET /invoices/number/:number
    const response = await axiosInstance.get(`/invoices/number/${encodeURIComponent(number)}`);
    return response.data;
  } catch (error) {
    throw formatError(error);
  }
};
